<template>
  <Row
    type="flex"
    justify="center"
    align="middle"
    style="min-height: 500px; height: 600px;"
  >
    <Col :xs="24" :sm="8" :md="8" :lg="6">
      <Card style="width:360px">
        <div style="text-align:center">
          <img src="../assets/logo.png" />
          <h1>uMerch Central Management</h1>
          <h3>Hệ thống quản lí thiết kế áo thun</h3>
        </div>
        <br />
        <Form
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          style="margin: 15px;"
          @submit.native.prevent="handleSubmit('formInline')"
        >
          <Row type="flex" justify="center">
            <Col :xs="24">
              <FormItem prop="user">
                <Input
                  v-model="formInline.user"
                  type="text"
                  placeholder="Tên đăng nhập"
                >
                  <Icon slot="prepend" type="ios-person-outline"></Icon>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24">
              <FormItem :xs="24" prop="password">
                <Input
                  v-model="formInline.password"
                  type="password"
                  placeholder="Mật khẩu"
                >
                  <Icon slot="prepend" type="ios-lock-outline"></Icon>
                </Input>
              </FormItem>
            </Col>
            <FormItem :xs="24">
              <Button type="primary" html-type="submit">Đăng nhập</Button>
            </FormItem>
          </Row>
        </Form>
      </Card>
    </Col>
  </Row>
</template>
<script>
export default {
  data() {
    return {
      formInline: {
        user: "",
        password: ""
      },
      ruleInline: {
        user: [
          {
            required: true,
            message: "Hãy nhập tên đăng nhập",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Hãy nhập mật khẩu",
            trigger: "blur"
          },
          {
            type: "string",
            min: 6,
            message: "Mật khẩu phải dài hơn 6 kí tự",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const self = this;
          this.$store
            .dispatch("auth/login", {
              username: this.formInline.user,
              password: this.formInline.password
            })
            .then(res => {
              console.log(res);
              if (parseInt(res.status / 100) == 2) {
                self.$Message.success("Đăng nhập thành công!");
                self.$router.push("/");
              } else {
                self.$Message.error("Xác thực thất bại! " + res.message);
              }
            })
            .catch(err => {
              console.debug(err);
              self.$Message.error(
                "Xác thực thất bại! Tên đăng nhập hoặc mật khẩu không đúng"
              );
            });
        } else {
          this.$Message.error("Xác thực thất bại!");
        }
      });
    }
  }
};
</script>
